module.exports = __webpack_public_path__ + "static/allrecrattle-7b9feb6b0fc0f2c3158ff8b64f1fe6f7.jpeg";